import { formatDate } from '@/utils/date'

const DocumentCategories = ({ documents, toggleCategory }) => {
    return (
        <>
            <h4 className="mt-4">Document categorization</h4>
            <div className="-mt-1 pb-2 text-sm text-slate-400">
                Define whether the Document applies as a Deed or a Lease
            </div>
            <div className="max-h-[25vh] overflow-auto rounded mb-4">
                
                <table className="table table-sm table-bordered table-zebra table-pin-rows bg-base-100">
                    <thead>
                        <tr>
                            <th>Document</th>
                            <th>Instrument Type</th>
                            <th>Instrument Date</th>
                            <th>Grantor</th>
                            <th>Grantee</th>
                            <th>Deed</th>
                            <th>Lease</th>
                        </tr>
                    </thead>
                    <tbody>
                        {documents.map((d, idx) => <tr key={d.id}>
                            <td><span className="line-clamp-1">{d.document.name}</span></td>
                            <td>{d.value.instrumentType}</td>
                            <td>{d.value.instrumentDate ? formatDate(d.value.instrumentDate) : ''}</td>
                            <td>{d.value.grantors.map(g => g.name).join('; ')}</td>
                            <td>{d.value.grantees.map(g => g.name).join('; ')}</td>
                            <td>
                                <input
                                    type="checkbox"
                                    className="checkbox checkbox-sm"
                                    checked={d.category.deed}
                                    onChange={evt => toggleCategory('deed', idx, evt.target.checked)} />
                            </td>
                            <td>
                                <input
                                    type="checkbox"
                                    className="checkbox checkbox-sm"
                                    checked={d.category.lease}
                                    onChange={evt => toggleCategory('lease', idx, evt.target.checked)} />
                            </td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default DocumentCategories